// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3QGe-","savePackageButton":"ClientWallet_savePackageButton__2Oq69"};